import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './i18n.js';
import App from './App.js';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Apply the saved theme before first paint; the Header (which owns the toggle) mounts only
// after the store loads, so without this the loading screen always shows in light mode.
try {
    document.body.classList.toggle('dark-theme', localStorage.getItem('selected-theme') === 'dark');
} catch {
    /* blocked storage — stay light */
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);

// Cloudflare Workers SPA returns index.html for missing /service-worker.js (text/html MIME).
// An old or broken SW also causes "flash then blank" after first paint — always unregister.
serviceWorkerRegistration.unregister();
